import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import './CommentSection.css';

function CommentSection({ postId, onCommentAdded }) {
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState('');
  const [loading, setLoading] = useState(false);

  const fetchComments = useCallback(async () => {
    try {
      const response = await axios.get(`/api/comments/post/${postId}`);
      setComments(response.data);
    } catch (error) {
      console.error('Error fetching comments:', error);
    }
  }, [postId]);

  useEffect(() => {
    fetchComments();
  }, [fetchComments]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!newComment.trim()) return;

    setLoading(true);
    try {
      const response = await axios.post(`/api/comments/post/${postId}`, {
        content: newComment
      });
      
      setComments([response.data, ...comments]);
      setNewComment('');
      onCommentAdded();
    } catch (error) {
      console.error('Error adding comment:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="comment-section">
      <form onSubmit={handleSubmit} className="comment-form">
        <input
          type="text"
          value={newComment}
          onChange={(e) => setNewComment(e.target.value)}
          placeholder="Write a comment..."
          maxLength="300"
        />
        <button type="submit" disabled={loading || !newComment.trim()}>
          Post
        </button>
      </form>

      <div className="comments-list">
        {comments.map(comment => {
          const displayName = comment.fullName || comment.username || 'User';
          return (
            <div key={comment.id} className="comment-item">
              <div className="comment-avatar">
                {displayName.charAt(0).toUpperCase()}
              </div>
              <div className="comment-content-wrapper">
                <div className="comment-author">{displayName}</div>
                <div className="comment-text">{comment.content}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default CommentSection;
